import React from 'react';
import PropTypes from 'prop-types';

function CartPriceItem(props) {
  const { title, subtitle, value } = props;
  return (
    <div className="cart-price">
      <p className="price-label">
        <span className="title">{title}</span>
        <br />
        <span className="subtitle">{subtitle}</span>
      </p>
      <p className="price-value">{value}</p>
    </div>
  );
}

CartPriceItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CartPriceItem;
